import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    urls: Object,
  };

  connect() {
    this.element.addEventListener("change", (e) => {
      const eventId = e.target.value;
      if (eventId && this.urlsValue[eventId]) {
        window.open(this.urlsValue[eventId], "_blank");
        e.target.value = "";
      }
    });
  }
}
